export default "__VITE_ASSET__BlKDBpox__"